var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"display-2"},[_vm._v(" No post was located with the title \""+_vm._s(_vm.title)+"\" 😬 ")])}
var staticRenderFns = []

export { render, staticRenderFns }